import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from '../store/utils';
import { FormattedDateTime } from '../utils/formatted-datetime';
import { SimpleTable } from './simple-table';

type Props = {
  title?: ReactNode;
};

export const ShelliesTable = ({
  title = <FormattedMessage id="shellies.list" defaultMessage="Shellies" />,
}: Props) => {
  const shellies = useSelector(
    ({ variables }) => variables.MQTT_BROKER_SHELLIES
  );

  return (
    <SimpleTable
      title={title}
      rows={[
        ['ID', 'Model', 'Stav', 'Poslední zpráva'],
        ...Object.entries(shellies).map(([key, value]) => {
          return [
            key,
            value.model,
            <>
              {(value.model === 'shellypro3em' ||
                value.model === 'shelly3em') && (
                <>
                  L1: {value.phase1ActualPower}W, L2: {value.phase2ActualPower}
                  W, L3: {value.phase3ActualPower}W
                </>
              )}

              {value.model === 'shellyproem50' && (
                <>
                  EM0: {value.em0ActualPower}W, EM1: {value.em1ActualPower}W
                </>
              )}

              {(value.model === 'shelly1pmg3' ||
                value.model === 'shelly1pmg4' ||
                value.model === 'shellypro1pm' ||
                value.model === 'shellyplusplugs') && (
                <>
                  {value.switch ? 'Zapnuto' : 'Vypnuto'}, {value.temperature}°C,{' '}
                  {value.power}W
                </>
              )}
            </>,
            <FormattedDateTime value={value.lastMessageAt} key={0} />,
          ];
        }),
      ]}
    />
  );
};
